import { GetRequestOptions } from "./grunt";

const getPth=process.env.REACT_APP_GRUNT_API+"/lokacija";
const StatusOk={status:200};

class Lokacija {
    constructor (id=0,sifra="",naziv="") {
        this.id=id;
        this.sifra=sifra;
        this.naziv=naziv;
    }
}
class Toviliste  {
    constructor (id=0,sifra="",naziv="",parentid=0) {
        this.id=id;
        this.sifra=sifra;
        this.naziv=naziv;
        this.parentid=parentid;
    }
}

class Odjeljak  {
    constructor (id=0,sifra="",naziv="",parentid=0) {
        this.id=id;
        this.sifra=sifra;
        this.naziv=naziv;
        this.parentid=parentid;
    }
}

const getLokacije_V2=async()=>{
    const pth=getPth+"/all_V2";
    try {
        const r = await fetch(pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getLokacije_V3=async()=>{
    const pth=getPth+"/all_V3";
    try {
        const r = await fetch(pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
const getLokacije=async(lokacijatipid,parentid=0)=>{
    let _lokc="/";
    
    if (lokacijatipid===2) {//toviliste
        _lokc=`/${parentid}/toviliste`;
    } else if (lokacijatipid===3) { //odjeljak
        _lokc=`/toviliste/${parentid}/odjeljak`;
    }
    let _pth=getPth+_lokc;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getLokacijeTovilistaOdjeljci=async()=>{

    let _pth=getPth+"/all";
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}
//allwithdefaultodjeljak
const getLokacijeAllWithDefaultOdjeljak=async()=>{

    let _pth=getPth+"/allwithdefaultodjeljak";
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getLokacijeForTreeView=async()=>{

    let _pth=getPth+"/tv";
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getLokacijeTovilistaOdjeljciByKnjigaid=async(knjigaid)=>{

    let _pth=getPth+"/all/" + knjigaid.toString();
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const addLokacija=async (lokacija)=>{
    let _pth=getPth;
    if (lokacija instanceof Lokacija) {
        _pth=getPth+"/";
    } else if (lokacija instanceof Toviliste) {
        _pth=getPth+`/${lokacija.parentid}/toviliste`;
    } else if (lokacija instanceof Odjeljak) {
        _pth=getPth+`/toviliste/${lokacija.parentid}/odjeljak`;
    } else {
        //greška
        _pth="";
    }
    try {
        if (_pth==="") {
            throw new Error('Greška u parametrima kod poziva metode [gruntweb.apiLokacija.addLokacija].');
        }
        let reqopt=GetRequestOptions("POST");
        if (lokacija instanceof Lokacija) {
            reqopt.body=JSON.stringify({sifra:lokacija.sifra,naziv:lokacija.naziv});    
        } else {
            reqopt.body=JSON.stringify({sifra:lokacija.sifra,naziv:lokacija.naziv,parentid:lokacija.parentid});    
        }
        
        const r=await fetch(_pth,reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message:  ex.message, status: ex.status, name: ex.name};
    }
}

const updateLokacija=async (lokacija)=>{
    let _pth=getPth;
    if (lokacija instanceof Lokacija) {
        _pth=getPth+`/${lokacija.id}`;
    } else if (lokacija instanceof Toviliste) {
        _pth=getPth+`/toviliste/${lokacija.id}`;
    } else if (lokacija instanceof Odjeljak) {
        _pth=getPth+`/odjeljak/${lokacija.id}`;
    } else {
        //greška
        _pth="";
    }
    try {
        if (_pth==="") {
            throw new Error('Greška u parametrima kod poziva metode [gruntweb.apiLokacija.updateLokacija].');
        }
        let reqopt=GetRequestOptions("PUT");
        reqopt.body=JSON.stringify({sifra:lokacija.sifra,naziv:lokacija.naziv});
        const r=await fetch(_pth,reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ispravka podatka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const deleteLokacija=async (lokacijaid)=>{
    let _pth=getPth+`/${lokacijaid}`
    
    try {
        if (_pth==="") {
            throw new Error('Greška u parametrima kod poziva metode [gruntweb.apiLokacija.updateLokacija].');
        }
        let reqopt=GetRequestOptions("DELETE");
        //reqopt.body=JSON.stringify({sifra:lokacija.sifra,naziv:lokacija.naziv});
        const r=await fetch(_pth,reqopt);
        
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else if (r.status===400) {
            StatusOk.status=400;
            StatusOk.res=res;
            return res;
        }
        else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ispravka podatka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const addGovedaInBoks=async (_lokacijaid,_govedaid=[])=>{
    const pth=getPth+`/${_lokacijaid}/goveda`;
    let reqopt=GetRequestOptions("POST");
    reqopt.body=JSON.stringify({govedaid:_govedaid});    
    try {
        const r=await fetch(pth,reqopt);
        const StatusOk={status:200};
        if (r.status===200) {
            return StatusOk;
        } else {
            const res=await r.json();
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod unosa podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

export {getLokacije, addLokacija, updateLokacija,deleteLokacija,getLokacijeTovilistaOdjeljci, addGovedaInBoks,getLokacije_V2,getLokacije_V3,
    Lokacija, Toviliste, Odjeljak,getLokacijeTovilistaOdjeljciByKnjigaid,getLokacijeForTreeView,getLokacijeAllWithDefaultOdjeljak};